const InternalServerError = () => {
  return (
    <div
      aria-label="Application error. This page is temporarily unavailable, please come back soon."
      className="h-[100vh] w-full bg-[#CECECE] p-0 pt-[20px] font-sans"
    >
      <div className="overflow-hidden bg-[#CECECE]">
        <a
          href="/"
          className="text-decoration-none block px-[16px] py-[14px] text-center text-[17px] text-black md:float-left"
        >
          <img
            src="https://shirtspace-web-assets.s3.us-west-2.amazonaws.com/500_logo.png"
            id="logo"
            className="mx-auto"
          />
        </a>
        <div className="text-center md:float-right">
          <form
            action="/search"
            method="get"
          >
            <input
              type="text"
              placeholder="Search by brand, color, style and more."
              name="search"
              className="mr-[3px] mt-[12px] h-[31px] w-[70%] border-none p-[6px] text-[17px] placeholder-gray100 md:w-[435px]"
            />
            <button
              className="ml-[5px] mr-[16px] mt-[12px] h-full cursor-pointer border-none bg-white px-[10px] py-[3px] text-[17px] hover:bg-[#CCC] md:float-right md:ml-0"
              type="submit"
            >
              Go
            </button>
          </form>
        </div>
      </div>
      <div className="relative mx-auto my-0 mt-[20px] w-full md:w-[80%]">
        <img
          alt="This page is temporarily unavailable, please come back soon."
          className="block w-full"
          src="https://shirtspace-web-assets.s3.us-west-2.amazonaws.com/500_message.jpg"
        />
        <a
          aria-label="Go back"
          className="absolute bottom-[8%] right-[21%] h-[50px] w-[160px]"
          href="/"
        ></a>
      </div>
    </div>
  );
};
export default InternalServerError;
